import env from 'env'

import Logger from './Logger'

const logger = new Logger

logger.level = env.logLevel

export default logger